import { uploadFile, GetPatientAttachmentsTypes } from '@/api/endpoints'
import { FileUpload } from '@/components/Exporter'
import MultiSelect from '@/components/formFields/DropDown/Multiselect'
import Popup from '@/components/popup'
import { SUPPORTED_FORMATS } from '@/components/popups/filesUploadPopup/components/UploadFile'
import { DomainContext } from '@/context/DomainContext'
import useFormData from '@/hooks/useFormData'
import { translate } from '@/utils/langUtils'
import { errorToast, successToast } from '@/utils/toasters'
import { useContext, useEffect, useState } from 'react'

const name = "upload-patient-medical-files"

export const defaultFiles = {
  "Lab Results Reports": "labReports",
  "X-ray/CT Image Reports": "xrayReports",
  "Medical Reports": "medicalReports",
}


const UploadPatientMedicalFiles = ({ setSelectedPatientId, modalID, patientId,apiCall }) => {
  const { ToggleReloadTable,loading,setLoading, } = useContext(DomainContext)
  const [files, setFiles] = useState({})
  const [categories, setCategories] = useState(null)
  const [sCategory, setsCategory] = useState(null)

  const { getFormData } = useFormData()


  useEffect(() => {
    GetPatientAttachmentsTypes().then((res) => {
      setCategories(res.data)
    })
  }, [])

  const handleUpload = () => {
    setLoading(true)
    if (!sCategory) {
      setLoading(false)
      errorToast("please-select-category")
      return
    }
    const fileData = getFormData(files)

    uploadFile(fileData).then((res) => {
      apiCall?.({
        patientId: patientId,
        attachmentIds: res.data,
      }).then(_ => {
        modalID.current?.click()
        successToast("operation-done-successfully")
        ToggleReloadTable((p) => !p)
      }).finally(_ => {
        handleClose()
        setLoading(false)
      })
    }).catch((err) => setLoading(false))
  }

  const handleClose = () => {
    setFiles([])
    setLoading(false)
    setsCategory(null)
    setSelectedPatientId(null)
  }

  return (
    <Popup className large={false} name={name} title={translate("upload-patient-medical-files")} onApply={handleUpload}
      modalID={modalID} btnName={loading ? "loading" : "upload"} resetAllFields={handleClose} >
      <MultiSelect options={categories}
        className='col-lg-12'
        label={'category'} isMulti={false}
        sOptions={sCategory} setSOptions={setsCategory} />

      <FileUpload
        accept={[SUPPORTED_FORMATS.image, SUPPORTED_FORMATS.pdf]}
        multiple
        value={files[defaultFiles[sCategory?.label]] || []}
        setValue={(value) => setFiles(prev => ({ ...prev, [defaultFiles[sCategory?.label]]: value }))}
        label={translate("upload-medical-files-hint")}
        isRequired={true}
      />
    </Popup>
  )
}

export default UploadPatientMedicalFiles